<template>
  <div>
    <div class="row">
      <div class="col-lg-3 col-md-12 col-pad">
          <!-- <div v-bind:style="{ 'background-color': 'rgba('+location.color+')'}" class="card"> -->
          <div class="card location-details-card">
            <img class="thumb" :src="location.picture" />
            <h2>{{location.name}}</h2>
            <ul class="menu">
              <li><router-link :to="{ name: 'trainings' }"><Fa iconStyle="far" icon='folder' /> Formations</router-link></li>
              <li><router-link :to="{ name: 'locations.home' }"><Fa iconStyle="fas" icon='map-marker-alt' /> Locations</router-link></li>
              <li><router-link :to="{ name: 'trainings' }"><Fa iconStyle="far" icon='user-circle' /> Apprenants</router-link></li>
              <li><router-link :to="{ name: 'trainings' }"><Fa iconStyle="fas" icon='book' /> Trames de formation</router-link></li>
            </ul>
          </div>
          
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios';

export default {
  middleware: 'auth',
  
  data() {
    return {
      location: [],
      errors: []
    }
  },

  // Fetches posts when the component is created.
  mounted() {
    axios.get(`/api/location/`+this.$route.params.key)
    .then(response => {
      // JSON responses are automatically parsed.
      this.location = response.data.data
    })
    .catch(e => {
      this.errors.push(e)
    })

    // async / await version (created() becomes async created())
    //
    // try {
    //   const response = await axios.get(`http://jsonplaceholder.typicode.com/posts`)
    //   this.posts = response.data
    // } catch (e) {
    //   this.errors.push(e)
    // }
  }
}
</script>





// WEBPACK FOOTER //
// src/layouts/detail.vue